import styled from 'styled-components';

export const StyledFieldset = styled.fieldset`
    &:disabled {
        & > * {
            filter: grayscale(1);
            pointer-events: none;
        }
    }
`;
